enum SpecialtyType {
  Insurance = '0',
  RealEstate = '1'
}

export default SpecialtyType
